import React, { useEffect, useState } from "react";
import {
  Alert,
  Modal,
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Table,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import SearchOrganizationalUnit from "./SearchOrganizationalUnit";

const UnitList = (props) => {
  //*States
  const [validated, setValidated] = useState(false);
  const [unidadSeleccionada, setUnidadSeleccionado] = useState({});
  //*Redux
  const { copiaError } = useSelector((store) => store.monitorOnBoarding);
  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);

  //*variables
  const dispatch = useDispatch();
  const schema = Yup.object().shape({
    unidad_organizativa: Yup.string().required("**Campo requerido"),
  });
  //* Methods
  const _getFuncionalAreas = (value = "") => {
    dispatch(getAreasJerarquia({ filter: value }, 2));
  };

  // useEffect(() => {
  //   if (props.item && props.item.unidad_organizativa) {
  //     setUnidadSeleccionado(props.item.list_unidad_organizativa[0]);
  //   }
  // }, [props.item]);

  const onSubmit = (req) => {
    let unidTemp = JSON.parse(req.unidad_organizativa);
    try {
      const existItem = props.unidListSelected.find(
        (rowItem) => rowItem.id === unidTemp.id
      );
      if (existItem) {
        toastr.info("La unidad ya han sido agregada", "", {
          progressBar: true,
          rtl: true,
        });
        return;
      }
    } catch (error) {
      toastr.info("La unidad no es valida", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    props.setUnidListSelected([...props.unidListSelected, unidTemp]);
    // setUnidSelected([]);
  };

  const handleRemoveUnid = (ind) => {
    const _unid = props.unidListSelected.slice();
    _unid.splice(ind, 1);
    props.setUnidListSelected(_unid);
    // props.handleClose();
  };

  return (
    <Modal size="md" show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h4 className="font-weight-bold text-uppercase m-0">
            <i
              className="flex-wrap material-icons"
              style={{ fontSize: "2rem", marginTop: "-.5rem" }}
            >
              app_registration
            </i>
            &nbsp;Lista Unidades
          </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            <Row>
              <Col>
                {!!copiaError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {copiaError}
                  </Alert>
                )}
                <Formik
                  validationSchema={schema}
                  onSubmit={onSubmit}
                  initialValues={{
                    unidad_organizativa: "",
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    values,
                    touched,
                    errors,
                  }) => (
                    <>
                      <Form
                        onSubmit={(e) => {
                          handleSubmit(e);
                          // setFieldValue("unidad_organizativa", "");
                        }}
                        noValidate
                        validated={validated}
                      >
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={loadingAreas ? 10 : 12}>
                            <SearchOrganizationalUnit
                              id="unidad_organizativa"
                              name="unidad_organizativa"
                              getFuncionalAreas={_getFuncionalAreas}
                              handleBlur={handleBlur}
                              areas={areas}
                              setFieldValue={setFieldValue}
                              isInvalid={
                                touched.unidad_organizativa &&
                                errors.unidad_organizativa
                              }
                              isValid={
                                touched.unidad_organizativa &&
                                !errors.unidad_organizativa
                              }
                              label=""
                              placeholder = "Unidad organizativa"
                            />
                          </Col>
                          {loadingAreas && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                        {touched.unidad_organizativa &&
                        errors.unidad_organizativa ? (
                          <small className="text-danger px-3">
                            {errors.unidad_organizativa}
                          </small>
                        ) : (
                          <small className="px-3">
                            **Búsqueda por: Código o nombre de la unidad
                          </small>
                        )}
                        <Col className="mt-3 pl-1">
                          <Button
                            disabled={values.unidad_organizativa === ""}
                            className="rounded-pill"
                            variant="primary"
                            type="submit"
                            // onClick={handleSubmit}
                          >
                            Agregar
                          </Button>
                        </Col>
                      </Form>
                    </>
                  )}
                </Formik>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <div>
                  {loadingAreas ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : props.unidListSelected.length > 0 ? (
                    // <Card>
                    <div class="table-responsive">
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.unidListSelected.map((item, ind) => (
                            <tr key={item.id}>
                              <td>{item.codigo}</td>
                              <td>{item.nombre}</td>
                              <td>
                                <Button
                                  variant="default"
                                  size="sm"
                                  className="ml-3"
                                  onClick={() => handleRemoveUnid(ind)}
                                >
                                  <i
                                    className="material-icons"
                                    style={{ fontSize: "1.3rem" }}
                                  >
                                    delete
                                  </i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    // </Card>
                    <Alert variant="info">
                      Aún no hay unidades agregadas a la tabla.
                    </Alert>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="rounded-pill"
          variant="secondary"
          onClick={props.handleClose}
        >
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnitList;
